export const PHASES = {
  open: { label: "Delai non demarre", cls: "bg-[#1E293B] text-[#CBD5E1]" },
  active: { label: "Disponible", cls: "bg-[#064E3B] text-[#6EE7B7]" },
  kept: { label: "5 photos conservees", cls: "bg-[#0C4A6E] text-[#7DD3FC]" },
  grace: { label: "Periode de grace", cls: "bg-[#78350F] text-[#FCD34D]" },
  expired: { label: "Expiree sans selection", cls: "bg-[#7F1D1D] text-[#FCA5A5]" },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export const timeLeft = (s) => {
  if (s == null) return "";
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  return d >= 1 ? `${d} jour${d > 1 ? "s" : ""}${h ? ` et ${h} h` : ""}` : `${h} heure${h > 1 ? "s" : ""}`;
};

export function PhaseBadge({ r, testId }) {
  if (!r) return null;
  const p = r.retention_disabled ? { label: "Sans expiration", cls: "bg-[#1E293B] text-[#CBD5E1]" } : PHASES[r.phase];
  return <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap shadow-sm ${p.cls}`} data-testid={testId}>{p.label}</span>;
}
